import React from "react";

const styles = {
    STRONG_BUY: { bg: "rgba(0,255,149,0.15)", color: "var(--green)", border: "var(--green)", label: "STRONG BUY" },
    BUY: { bg: "rgba(0,255,149,0.08)", color: "var(--green)", border: "rgba(0,255,149,0.4)", label: "BUY" },
    HOLD: { bg: "rgba(255,209,59,0.08)", color: "var(--yellow)", border: "rgba(255,209,59,0.4)", label: "HOLD" },
    SELL: { bg: "rgba(255,59,92,0.08)", color: "var(--red)", border: "rgba(255,59,92,0.4)", label: "SELL" },
    STRONG_SELL: { bg: "rgba(255,59,92,0.15)", color: "var(--red)", border: "var(--red)", label: "STRONG SELL" },
};

export const SignalBadge = ({ action, confidence, size = "sm" }) => {
    const s = styles[action] || styles.HOLD;
    const padding = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
    return (
        <span
            data-testid={`signal-${action}`}
            className={`inline-flex items-center gap-1.5 font-bold tracking-wider ${padding} border`}
            style={{ background: s.bg, color: s.color, borderColor: s.border }}
        >
            {s.label}
            {confidence !== undefined && <span className="opacity-70 tnum">{confidence}%</span>}
        </span>
    );
};
